import React, { useEffect, useState } from 'react'
import { GetCurrentUserInfo_User_Api } from '../../API/userApi';
import { Col, Popover, Row } from 'antd';
import { useNavigate } from "react-router-dom";

// =================================================================
export const UserAvatarComponent = ({ setLoading, showMessage, profileVersion, editProfileClicked }) => {
    // =================================================================
    const [user, setUser] = useState();
    const navigate = useNavigate();
    // =================================================================
    const content = (
        <div style={{ cursor: 'pointer' }}>
            <p onClick={() => { if (editProfileClicked) editProfileClicked() }}>پروفایل</p>
            <p onClick={() => { localStorage.removeItem('token'); localStorage.removeItem('rle'); navigate("/login"); }}>خروج</p>
        </div>
    );
    // =================================================================
    useEffect(() => {
        loadData();
    }, [profileVersion]);
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetCurrentUserInfo_User_Api();
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setUser(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    return (
        <>
            {user ?

                <Row justify={'end'} style={{ cursor: 'pointer' }}>
                    <Col style={{ paddingLeft: '5px' }}>
                        <Popover placement="bottomLeft" title=' ' content={content}>
                            {user.name + ' ' + user.family}
                        </Popover>
                    </Col>
                    <Col>
                        <Popover placement="bottomLeft" title=' ' content={content}>
                            <img style={{ width: '30px', borderRadius: '50%' }} src={user.photoUrl} />
                        </Popover>
                    </Col>
                </Row>

                : <></>
            }
        </>
    )
}

